import omitDeep from 'omit-deep-lodash';

const happenedCardsRaw = [
  {
    cardType: 'HAPPENED',
    isPositive: false,
    emoji: '🤔',
    title: "I don't know",
    titleHe: 'אני לא יודע',
    titleAr: 'لا أعرف',
    titleRu: 'Я не знаю',
    prefix: '',
    prefixHe: '',
    prefixAr: '',
    prefixRu: '',
    title_male: "I don't know",
    title_female: "I don't know",
    titleHe_male: 'אני לא יודע',
    titleHe_female: 'אני לא יודעת',
    titleAr_male: 'لا أعرف',
    titleAr_female: 'لا أعرف',
    titleRu_male: 'Я не знаю',
    titleRu_female: 'Я не знаю'
  },
{
    cardType: 'HAPPENED',
    isPositive: false,
    description: '',
    emoji: '🙊',
    title: "I don't want to share",
    titleHe: 'לא בא לי לשתף',
    titleAr: 'لا أريد المشاركة',
    titleRu: 'Я не хочу делиться',
    prefix: '',
    prefixHe: '',
    prefixAr: '',
    prefixRu: '',
    title_male: "I don't want to share",
    title_female: "I don't want to share",
    titleHe_male: 'לא בא לי לשתף',
    titleHe_female: 'לא בא לי לשתף',
    titleAr_male: 'لا أريد المشاركة',
    titleAr_female: 'لا أريد المشاركة',
    titleRu_male: 'Я не хочу делиться',
    titleRu_female: 'Я не хочу делиться',
    descriptionHe: 'לא בא לי לשתף',
    descriptionAr: 'لا أريد المشاركة',
    descriptionRu: 'Я не хочу делиться'
  },
  {
    cardType: 'HAPPENED',
    isPositive: false,
    description: '',
    emoji: '😶',
    title: 'Nothing',
    titleHe: 'לא עושה כלום',
    titleAr: 'لا شيء',
    titleRu: 'Ничего',
    prefix: '',
    prefixHe: 'ל',
    prefixAr: 'ل',
    prefixRu: '',
    title_male: 'Nothing',
    title_female: 'Nothing',
    titleHe_male: 'לא עושה כלום',
    titleHe_female: 'לא עושה כלום',
    titleAr_male: 'لا يفعل شيئاً',
    titleAr_female: 'لا تفعل شيئاً',
    titleRu_male: 'Ничего не делает',
    titleRu_female: 'Ничего не делает',
    descriptionHe: 'לא עושה כלום',
    descriptionAr: 'لا يفعل شيئاً',
    descriptionRu: 'Ничего не делает'
  },
  {
    cardType: 'HAPPENED',
    isPositive: true,
    description: 'A profoundly affection for another person.',
    descriptionAr: 'مشاعر عميقة من المودة لشخص آخر.',
    descriptionRu: 'Глубокая привязанность к другому человеку.',
    emoji: '❤️',
    prefix: 'to',
    prefixHe: 'ל',
    prefixAr: 'ل',
    prefixRu: 'к',
    title: 'Show love',
    titleHe: 'מראה אהבה',
    titleAr: 'يظهر الحب',
    titleRu: 'Проявляет любовь',
    title_male: 'Show love',
    title_female: 'Show love',
    titleHe_male: 'מראה אהבה',
    titleHe_female: 'מראה אהבהת',
    titleAr_male: 'يُظهر الحب',
    titleAr_female: 'تُظهر الحب',
    titleRu_male: 'Проявляет любовь',
    titleRu_female: 'Проявляет любовь',
    descriptionHe: 'מראה אהבה'
  },
  {
    cardType: 'HAPPENED',
    isPositive: true,
    emoji: '👏',
    prefix: '',
    prefixHe: 'את',
    prefixAr: '',
    prefixRu: '',
    title: 'Cheers',
    titleHe: 'מעודד',
    titleAr: 'يشجع',
    titleRu: 'Подбадривает',
    title_male: 'Cheers',
    title_female: 'Cheers',
    titleHe_male: 'מעודד',
    titleHe_female: 'מעודדת',
    titleAr_male: 'يشجع',
    titleAr_female: 'تشجع',
    titleRu_male: 'Подбадривает',
    titleRu_female: 'Подбадривает'
  },
  {
    cardType: 'HAPPENED',
    isPositive: true,
    emoji: ' 😊',
    title: 'Forgave',
    titleHe: 'סולח',
    titleAr: 'سامح',
    titleRu: 'Простил',
    prefix: '',
    prefixHe: 'ל',
    prefixAr: 'ل',
    prefixRu: '',
    title_male: 'Forgave',
    title_female: 'Forgave',
    titleHe_male: 'סולח',
    titleHe_female: 'סולחת',
    titleAr_male: 'سامح',
    titleAr_female: 'سامحت',
    titleRu_male: 'Простил',
    titleRu_female: 'Простила'
  },
  {
    cardType: 'HAPPENED',
    isPositive: true,
    emoji: '🛡️',
    title: 'Protects',
    titleHe: 'שומר',
    titleAr: 'يحمي',
    titleRu: 'Защищает',
    prefix: ' ',
    prefixHe: 'על',
    prefixAr: 'على',
    prefixRu: '',
    title_male: 'Protects',
    title_female: 'Protects',
    titleHe_male: 'שומר',
    titleHe_female: 'שומרת',
    titleAr_male: 'يحمي',
    titleAr_female: 'تحمي',
    titleRu_male: 'Защищает',
    titleRu_female: 'Защищает'
  },
  {
    cardType: 'HAPPENED',
    isPositive: true,
    emoji: '😊',
    title: 'Show affection',
    titleHe: 'מראה חיבה',
    titleAr: 'يظهر المودة',
    titleRu: 'Проявляет привязанность',
    prefix: 'to',
    prefixHe: 'ל',
    prefixAr: 'ل',
    prefixRu: 'к',
    title_male: 'Show affection',
    title_female: 'Show affection',
    titleHe_male: 'מראה חיבה',
    titleHe_female: 'מראה חיבה',
    titleAr_male: 'يُظهر المودة',
    titleAr_female: 'تُظهر المودة',
    titleRu_male: 'Проявляет привязанность',
    titleRu_female: 'Проявляет привязанность'
  },
  {
    cardType: 'HAPPENED',
    isPositive: true,
    emoji: '😂',
    title: 'Laughs',
    titleHe: 'צוחק',
    titleAr: 'يضحك',
    titleRu: 'Смеётся',
    prefix: 'with',
    prefixHe: 'עם',
    prefixAr: 'مع',
    prefixRu: 'с',
    title_male: 'Laughs',
    title_female: 'Laughs',
    titleHe_male: 'צוחק',
    titleHe_female: 'צוחקת',
    titleAr_male: 'يضحك',
    titleAr_female: 'تضحك',
    titleRu_male: 'Смеётся',
    titleRu_female: 'Смеётся'
  },
  {
    cardType: 'HAPPENED',
    isPositive: false,
    emoji: '👹',
    title: 'Mocks',
    titleHe: 'לועג',
    titleAr: 'يسخر',
    titleRu: 'Издевается',
    prefix: '',
    prefixHe: 'ל',
    prefixAr: 'ل',
    prefixRu: 'над',
    title_male: 'Mocks',
    title_female: 'Mocks',
    titleHe_male: 'לועג',
    titleHe_female: 'לועגת',
    titleAr_male: 'يسخر',
    titleAr_female: 'تسخر',
    titleRu_male: 'Издевается',
    titleRu_female: 'Издевается'
  },
  {
    cardType: 'HAPPENED',
    isPositive: true,
    emoji: '🤗',
    title: 'Hugs',
    titleHe: 'מחבק',
    titleAr: 'يعانق',
    titleRu: 'Обнимает',
    prefix: '',
    prefixHe: 'את',
    prefixAr: '',
    prefixRu: '',
    title_male: 'Hugs',
    title_female: 'Hugs',
    titleHe_male: 'מחבק',
    titleHe_female: 'מחבקת',
    titleAr_male: 'يعانق',
    titleAr_female: 'تعانق',
    titleRu_male: 'Обнимает',
    titleRu_female: 'Обнимает'
  },
  {
    cardType: 'HAPPENED',
    isPositive: true,
    emoji: '😌',
    title: 'Polite',
    titleHe: 'מנומס',
    titleAr: 'مهذب',
    titleRu: 'Вежливый',
    prefix: 'to',
    prefixHe: 'כלפי',
    prefixAr: 'تجاه',
    prefixRu: 'по отношению к',
    title_male: 'Respects',
    title_female: 'Respects',
    titleHe_male: 'מנומס',
    titleHe_female: 'מנומסת',
    titleAr_male: 'يحترم',
    titleAr_female: 'تحترم',
    titleRu_male: 'Вежливый',
    titleRu_female: 'Вежливая'
  },
  {
    cardType: 'HAPPENED',
    isPositive: true,
    emoji: '👂',
    title: 'Listens',
    titleHe: 'מקשיב',
    titleAr: 'يستمع',
    titleRu: 'Слушает',
    prefix: 'to',
    prefixHe: 'ל',
    prefixAr: 'ل',
    prefixRu: '',
    title_male: 'Listens',
    title_female: 'Listens',
    titleHe_male: 'מקשיב',
    titleHe_female: 'מקשיבה',
    titleAr_male: 'يستمع',
    titleAr_female: 'تستمع',
    titleRu_male: 'Слушает',
    titleRu_female: 'Слушает'
  },
  {
    cardType: 'HAPPENED',
    isPositive: false,
    emoji: '🥊',
    title: 'Hits',
    titleHe: 'נותן מכה',
    titleAr: 'يضرب',
    titleRu: 'Бьёт',
    prefix: '',
    prefixHe: 'ל',
    prefixAr: 'ل',
    prefixRu: '',
    title_male: 'Hits',
    title_female: 'Hits',
    titleHe_male: 'נותן מכה',
    titleHe_female: 'נותנת מכה',
    titleAr_male: 'يضرب',
    titleAr_female: 'تضرب',
    titleRu_male: 'Бьёт',
    titleRu_female: 'Бьёт'
  },
{
    cardType: 'HAPPENED',
    isPositive: false,
    emoji: '⛏',
    title: 'Annoying',
    titleRu: 'Раздражает',
    titleHe: 'חופר',
    prefix: '',
    prefixHe: 'ל',
    prefixAr: 'ل',
    prefixRu: '',
    title_male: 'Annoying',
    title_female: 'Annoying',
    titleHe_male: 'חופר',
    titleHe_female: 'חופרת',
    titleAr_male: 'مزعج',
    titleAr_female: 'مزعجة',
    titleRu_male: 'Раздражает',
    titleRu_female: 'Раздражает'
  },
  {
    cardType: 'HAPPENED',
    isPositive: true,
    emoji: '🏀',
    title: 'Plays',
    titleRu: 'Играет',
    titleHe: '',
    titleAr: 'يلعب',
    prefix: 'with',
    prefixHe: 'עם',
    prefixAr: 'مع',
    prefixRu: 'с',
    title_male: 'Plays',
    title_female: 'Plays',
    titleHe_male: 'משחק',
    titleHe_female: 'משחקת',
    titleAr_male: 'يلعب',
    titleAr_female: 'تلعب',
    titleRu_male: 'Играет',
    titleRu_female: 'Играет'
  },
  {
    cardType: 'HAPPENED',
    isPositive: true,
    emoji: '💬',
    title: 'talk',
    titleRu: 'Разговаривает',
    titleHe: 'מדבר',
    titleAr: 'يتحدث',
    prefix: 'with',
    prefixHe: 'עם',
    prefixAr: 'مع',
    prefixRu: 'с',
    title_male: 'talk',
    title_female: 'talk',
    titleHe_male: 'מדבר',
    titleHe_female: 'מדברת',
    titleAr_male: 'يتحدث',
    titleAr_female: 'تتحدث',
    titleRu_male: 'Разговаривает',
    titleRu_female: 'Разговаривает'
    },
    {
    cardType: 'HAPPENED',
    isPositive: false,
    emoji: '🤐',
    title: "Isn't speaking",
    titleRu: 'Не разговаривает',
    titleHe: 'לא מדבר',
    titleAr: 'لا يتحدث',
    prefix: 'with',
    prefixHe: 'מ',
    prefixAr: 'مع',
    prefixRu: 'с',
    title_male: "Isn't speaking",
    title_female: "Isn't speaking",
    titleHe_male: 'לא מדבר',
    titleHe_female: 'לא מדברת',
    titleAr_male: 'لا يتحدث',
    titleAr_female: 'لا تتحدث',
    titleRu_male: 'Не разговаривает',
    titleRu_female: 'Не разговаривает'
    },
    {
    cardType: 'HAPPENED',
    isPositive: false,
    emoji: '🤭',
    title: 'Hiding something',
    titleRu: 'Что-то скрывает',
    titleHe: 'מסתיר משהו',
    titleAr: 'يخفي شيئاً',
    prefix: 'from',
    prefixHe: 'מ',
    prefixAr: 'من',
    prefixRu: 'от',
    title_male: 'Surprised',
    title_female: 'Surprised',
    titleHe_male: 'מסתיר משהו',
    titleHe_female: 'מסתירה משהו',
    titleAr_male: 'يخفي شيئاً',
    titleAr_female: 'تخفي شيئاً',
    titleRu_male: 'Что-то скрывает',
    titleRu_female: 'Что-то скрывает'
    },
    {
    cardType: 'HAPPENED',
    isPositive: false,
    emoji: '🤥',
    title: 'Lying',
    titleRu: 'Врёт',
    titleHe: 'משקר',
    titleAr: 'يكذب',
    prefix: 'to',
    prefixHe: 'ל',
    prefixAr: 'على',
    prefixRu: '',
    title_male: 'Surprised',
    title_female: 'Surprised',
    titleHe_male: 'משקר',
    titleHe_female: 'משקרת',
    titleAr_male: 'يكذب',
    titleAr_female: 'تكذب',
    titleRu_male: 'Врёт',
    titleRu_female: 'Врёт'
    },
    {
    cardType: 'HAPPENED',
    isPositive: false,
    emoji: '😢',
    title: 'Offended',
    titleRu: 'Обижен',
    titleHe: 'נעלב',
    titleAr: 'مُهان',
    prefix: 'from',
    prefixHe: 'מ',
    prefixAr: 'من',
    prefixRu: 'на',
    title_male: 'Insults',
    title_female: 'Insults',
    titleHe_male: 'נעלב',
    titleHe_female: 'נעלבת',
    titleAr_male: 'مُهان',
    titleAr_female: 'مُهانة',
    titleRu_male: 'Обижен',
    titleRu_female: 'Обижена'
    },
    {
    cardType: 'HAPPENED',
    isPositive: false,
    emoji: '🙄',
    title: 'inconsiderate',
    titleRu: 'Не считается',
    titleHe: '',
    titleAr: 'غير مبالٍ',
    prefix: 'with',
    prefixHe: 'ב',
    prefixAr: 'بـ',
    prefixRu: 'с',
    title_male: 'inconsiderate',
    title_female: 'inconsiderate',
    titleHe_male: 'לא מתחשב',
    titleHe_female: 'לא מתחשבת',
    titleAr_male: 'غير مبالٍ',
    titleAr_female: 'غير مبالية',
    titleRu_male: 'Не считается',
    titleRu_female: 'Не считается'
    },
    {
    cardType: 'HAPPENED',
    isPositive: true,
    emoji: '🤲',
    title: 'Explain',
    titleRu: 'Объясняет',
    titleHe: '',
    titleAr: 'يشرح',
    prefix: 'to',
    prefixHe: 'ל',
    prefixAr: 'ل',
    prefixRu: '',
    title_male: 'Explain himself',
    title_female: 'Explain herself',
    titleHe_male: 'מסביר את עצמו',
    titleHe_female: 'מסבירה את עצמה',
    titleAr_male: 'يشرح نفسه',
    titleAr_female: 'تشرح نفسها',
    titleRu_male: 'Объясняет',
    titleRu_female: 'Объясняет'
    },
    {
    cardType: 'HAPPENED',
    isPositive: true,
    emoji: '🙌',
    title: 'Show trust',
    titleRu: 'Доверяет',
    titleHe: 'מראה אמון',
    titleAr: 'يظهر الثقة',
    prefix: 'towards',
    prefixHe: 'ב',
    prefixAr: 'تجاه',
    prefixRu: '',
    title_male: 'Show trust',
    title_female: 'Show trust',
    titleHe_male: 'מראה אמון',
    titleHe_female: 'מראה אמון',
    titleAr_male: 'يُظهر الثقة',
    titleAr_female: 'تُظهر الثقة',
    titleRu_male: 'Доверяет',
    titleRu_female: 'Доверяет'
    },
  {
    cardType: 'HAPPENED',
    isPositive: false,
    emoji: '😤',
    title: 'Impatient',
    titleHe: 'חסר סבלנות',
    titleRu: 'Нетерпеливый',
    prefix: 'with',
    prefixHe: 'כלפי',
    prefixRu: 'к',
    title_male: 'Impatient',
    title_female: 'Impatient',
    titleHe_male: 'חסר סבלנות',
    titleHe_female: 'חסרת סבלנות',
    titleAr: 'عديم الصبر',
    prefixAr: 'تجاه',
    titleAr_male: 'عديم الصبر',
    titleAr_female: 'عديمة الصبر'
  },
  {
    cardType: 'HAPPENED',
    isPositive: false,
    emoji: '😟',
    title: 'Anxious',
    titleHe: 'בחרדות',
    titleRu: 'В тревоге',
    prefix: 'because of',
    prefixHe: 'בגלל',
    prefixRu: 'из-за',
    title_male: 'Anxious',
    title_female: 'Anxious',
    titleHe_male: 'בחרדות',
    titleHe_female: 'בחרדות',
    titleAr: 'قلق',
    prefixAr: 'بسبب',
    titleAr_male: 'قلق',
    titleAr_female: 'قلقة'
  },
  {
    cardType: 'HAPPENED',
    isPositive: false,
    emoji: '👻',
    title: 'Sows fear',
    titleHe: 'זורע פחדים',
    titleRu: 'Сеет страх',
    prefix: 'in',
    prefixHe: 'ב',
    prefixRu: 'в',
    title_male: 'Sows fear',
    title_female: 'Sows fear',
    titleHe_male: 'זורע פחדים',
    titleHe_female: 'זורעת פחדים',
    titleAr: 'يزرع الخوف',
    prefixAr: 'في',
    titleAr_male: 'يزرع الخوف',
    titleAr_female: 'تزرع الخوف'
  },
  {
    cardType: 'HAPPENED',
    isPositive: false,
    emoji: '🤔',
    title: 'Condescending',
    titleHe: 'מתנשא',
    titleRu: 'Ведёт себя высокомерно',
    prefix: '',
    prefixHe: 'על',
    prefixRu: 'над',
    title_male: 'Condescending',
    title_female: 'Condescending',
    titleHe_male: 'מתנשא',
    titleHe_female: ' מתנשאת',
    titleAr: 'يتعالى',
    prefixAr: 'على',
    titleAr_male: 'يتعالى',
    titleAr_female: 'تتعالى'
  },
  {
    cardType: 'HAPPENED',
    isPositive: false,
    emoji: '☝',
    title: 'Demands',
    titleHe: 'דורש',
    titleRu: 'Требует',
    prefix: 'from',
    prefixHe: 'מ',
    prefixRu: 'от',
    title_male: 'Demands',
    title_female: 'Demands',
    titleHe_male: 'דורש',
    titleHe_female: ' דורשת',
    titleAr: 'يطالب',
    prefixAr: 'من',
    titleAr_male: 'يطالب',
    titleAr_female: 'تطالب'
  },
  {
    cardType: 'HAPPENED',
    isPositive: false,
    emoji: '😳',
    title: 'Acts strangely',
    titleHe: 'מתנהג מוזר',
    titleRu: 'Ведёт себя странно',
    prefix: 'around',
    prefixHe: 'ליד',
    prefixRu: 'рядом с',
    title_male: 'Acts strangely',
    title_female: 'Acts strangely',
    titleHe_male: 'מתנהג מוזר',
    titleHe_female: 'מתנהגת מוזר',
    titleAr: 'يتصرف بغرابة',
    prefixAr: 'بالقرب من',
    titleAr_male: 'يتصرف بغرابة',
    titleAr_female: 'تتصرف بغرابة'
  },
  {
    cardType: 'HAPPENED',
    isPositive: true,
    emoji: '😌',
    title: 'Acts patiently',
    titleHe: 'מתנהג בסובלנות',
    titleRu: 'Ведёт себя терпеливо',
    prefix: 'towards',
    prefixHe: 'כלפי',
    prefixRu: 'к',
    title_male: 'Acts patiently',
    title_female: 'Acts patiently',
    titleHe_male: 'מתנהג בסובלנות',
    titleHe_female: 'מתנהגת בסובלנות',
    titleAr: 'يتصرف بصبر',
    prefixAr: 'تجاه',
    titleAr_male: 'يتصرف بصبر',
    titleAr_female: 'تتصرف بصبر'
  },
  {
    cardType: 'HAPPENED',
    isPositive: false,
    emoji: '🤩',
    title: 'Boasts',
    titleHe: 'משוויץ',
    titleRu: 'Хвастается',
    prefix: 'to',
    prefixHe: 'בפני',
    prefixRu: 'перед',
    title_male: 'Boasts',
    title_female: 'Boasts',
    titleHe_male: 'משוויץ',
    titleHe_female: 'משוויצה',
    titleAr: 'يتباهى',
    prefixAr: 'أمام',
    titleAr_male: 'يتباهى',
    titleAr_female: 'تتباهى'
  },
  {
    cardType: 'HAPPENED',
    isPositive: false,
    emoji: '😒',
    title: 'Ignores',
    titleHe: 'מתעלם',
    titleRu: 'Игнорирует',
    prefix: '',
    prefixHe: 'מ',
    prefixRu: '',
    title_male: 'Ignores',
    title_female: 'Ignores',
    titleHe_male: 'מתעלם',
    titleHe_female: 'מתעלמת',
    titleAr: 'يتجاهل',
    prefixAr: 'من',
    titleAr_male: 'يتجاهل',
    titleAr_female: 'تتجاهل'
  },
  {
    cardType: 'HAPPENED',
    isPositive: false,
    emoji: '😔',
    title: 'Disappointed',
    titleHe: 'מאוכזב',
    titleRu: 'Разочарован',
    prefix: 'of',
    prefixHe: 'מ',
    prefixRu: 'в',
    title_male: 'Disappointed',
    title_female: 'Disappointed',
    titleHe_male: 'מאוכזב',
    titleHe_female: 'מאוכזבת',
    titleAr: 'يتصرف بخيبة أمل',
    prefixAr: 'من',
    titleAr_male: 'يتصرف بخيبة أمل',
    titleAr_female: 'تتصرف بخيبة أمل'
  }
]


const feelCardsRaw = [
  {
    cardType: 'FEEL',
    isPositive: false,
    description: 'Uncertain or lacking an answer.',
    descriptionHe: 'חוסר ודאות או היעדר תשובה.',
    descriptionAr: 'غير متأكد أو يفتقر إلى إجابة.',
    descriptionRu: 'Неуверенность или отсутствие ответа.',
    emoji: '🤔',
    title: "I don't know",
    titleHe: 'אני לא יודע/ת',
    titleAr: 'لا أعرف',
    titleRu: 'Я не знаю'
  },
  {
    cardType: 'FEEL',
    isPositive: false,
    description: 'Not willing to express or reveal information.',
    descriptionHe: 'לא מעוניין/ת לחשוף או לשתף מידע.',
    descriptionAr: 'غير راغب في الإفصاح أو مشاركة المعلومات.',
    descriptionRu: 'Не желающий выражать или раскрывать информацию.',
    emoji: '🙊',
    title: "I don't want to share",
    titleHe: 'לא בא לי לשתף',
    titleAr: 'لا أريد أن أشارك',
    titleRu: 'Я не хочу делиться'
  },
  {
    cardType: 'FEEL',
    isPositive: false,
    description: 'A lack of interest, concern, or emotion about something.',
    descriptionHe: 'חוסר עניין, אכפתיות או רגש כלפי משהו.',
    descriptionAr: 'عدم اهتمام أو اكتراث أو شعور تجاه شيء ما.',
    descriptionRu: 'Отсутствие интереса, заботы или эмоций по поводу чего-либо.',
    emoji: '😐',
    title: "I don't care",
    titleHe: 'לא אכפת לי',
    titleAr: 'لا أهتم',
    titleRu: 'Мне всё равно'
  },
  {
    cardType: 'FEEL',
    isPositive: false,
    description: 'Absence of anything to say or report.',
    descriptionHe: 'אין מה לומר או לדווח.',
    descriptionAr: 'لا يوجد ما يُقال أو يُذكر.',
    descriptionRu: 'Отсутствие чего-либо, что можно сказать или сообщить.',
    emoji: '😶',
    title: 'Nothing',
    titleHe: 'שום דבר',
    titleAr: 'لا شيء',
    titleRu: 'Ничего'
  },
  {
    cardType: 'FEEL',
    isPositive: false,
    description: 'A desire to be by oneself without interaction or disturbance.',
    descriptionHe: 'רצון להיות לבד בלי אינטראקציה או הפרעה.',
    descriptionAr: 'الرغبة في أن أكون وحدي دون تفاعل أو إزعاج.',
    descriptionRu: 'Желание быть одним без взаимодействия или помех.',
    emoji: '🙅‍♂️',
    title: 'Leave me alone',
    titleHe: 'תעזבו אותי בשקט',
    titleAr: 'اتركني وحدي',
    titleRu: 'Оставь меня в покое'
  },
  {
    cardType: 'FEEL',
    isPositive: true,
    description: 'A profoundly affectionate feeling for another person.',
    descriptionHe: 'תחושת חיבה עמוקה כלפי אדם אחר.',
    descriptionAr: 'شعور مودة عميقة تجاه شخص آخر.',
    descriptionRu: 'Глубокое чувство привязанности к другому человеку.',
    emoji: '❤️',
    title: 'Love',
    titleHe: 'אהבה',
    titleAr: 'حب',
    titleRu: 'Любовь'
  },
  {
    cardType: 'FEEL',
    isPositive: false,
    description: 'Crushed with sorrow or grief.',
    descriptionHe: 'מוצף בעצב או צער עמוק.',
    descriptionAr: 'مُحطَّم بالحزن أو الأسى.',
    descriptionRu: 'Сокрушённый горем или печалью.',
    emoji: '💔',
    title: 'Heart Broken',
    titleHe: 'שברון לב',
    titleAr: 'قلب مكسور',
    titleRu: 'Разбитое сердце'
  },
  {
    cardType: 'FEEL',
    isPositive: false,
    description: 'A sense of injustice or unfair treatment.',
    descriptionHe: 'תחושת חוסר צדק או יחס לא הוגן.',
    descriptionAr: 'شعور بالظلم أو المعاملة غير العادلة.',
    descriptionRu: 'Чувство несправедливости или нечестного обращения.',
    emoji: '👎',
    title: 'Not fair',
    titleHe: 'לא פייר',
    titleAr: 'غير عادل',
    titleRu: 'Нечестно'
  },
  {
    cardType: 'FEEL',
    isPositive: true,
    description: 'A feeling of deep satisfaction with achievements.',
    descriptionHe: 'תחושת שביעות רצון והערכה מהישגים.',
    descriptionAr: 'شعور بالرضا العميق عن الإنجازات.',
    descriptionRu: 'Чувство глубокого удовлетворения достижениями.',
    emoji: '🏆',
    title: 'Proud',
    titleHe: 'גאווה',
    titleAr: 'فخور',
    titleRu: 'Горжусь'
  },
  {
    cardType: 'FEEL',
    isPositive: true,
    description: 'A state of joy, contentment, or pleasure.',
    descriptionHe: 'מצב של שמחה, סיפוק או הנאה.',
    descriptionAr: 'حالة من الفرح أو الرضا أو المتعة.',
    descriptionRu: 'Состояние радости, удовлетворения или удовольствия.',
    emoji: '😊',
    title: 'Happiness',
    titleHe: 'שמחה',
    titleAr: 'سعادة',
    titleRu: 'Счастье'
  },
  {
    cardType: 'FEEL',
    isPositive: true,
    description: 'Inspired with courage, spirit, or confidence.',
    descriptionHe: 'מקבל השראה לאומץ, רוח או ביטחון.',
    descriptionAr: 'ملهم بالشجاعة أو الروح أو الثقة.',
    descriptionRu: 'Вдохновлённый мужеством, духом или уверенностью.',
    emoji: '🌺',
    title: 'Meaningful',
    titleHe: 'משמעות',
    titleAr: 'ذو معنى',
    titleRu: 'Значимо'
  },
  {
    cardType: 'FEEL',
    isPositive: true,
    description: 'Guarded, taken care of, embraced and shielded.',
    descriptionHe: 'מוגן, מטופל, מחובק ומוגן.',
    descriptionAr: 'محمي، مُعتنى به، مُحتضن ومحصن.',
    descriptionRu: 'Защищённый, ухоженный, обнятый и ограждённый.',
    emoji: '🛡',
    title: 'Protected',
    titleHe: 'ביטחון',
    titleAr: 'محمي',
    titleRu: 'Защищённый'
  },
  {
    cardType: 'FEEL',
    isPositive: true,
    description: 'Having a warm and loving sensation.',
    descriptionHe: 'תחושה חמה ואוהבת.',
    descriptionAr: 'شعور دافئ ومحب.',
    descriptionRu: 'Тёплое и любящее ощущение.',
    emoji: '😊',
    title: 'Affection',
    titleHe: 'חום',
    titleAr: 'مودة',
    titleRu: 'Привязанность'
  },
  {
    cardType: 'FEEL',
    isPositive: true,
    description: 'Having a warm and loving sensation.',
    descriptionHe: 'תחושה חמה ואוהבת.',
    descriptionAr: 'شعور دافئ ومحب.',
    descriptionRu: 'Тёплое и любящее ощущение.',
    emoji: '🐰',
    title: 'Cute',
    titleHe: 'חמידות',
    titleAr: 'لطيف',
    titleRu: 'Милый'
  },
  {
    cardType: 'FEEL',
    isPositive: true,
    description: 'Being relaxed, in both body and mind, without stress or hard emotions.',
    descriptionHe: 'רוגע בגוף ובנפש, ללא מתח או רגשות קשים.',
    descriptionAr: 'استرخاء في الجسد والعقل، دون توتر أو مشاعر صعبة.',
    descriptionRu: 'Расслабленность телом и разумом, без стресса или тяжёлых эмоций.',
    emoji: '😌',
    title: 'Calm',
    titleHe: 'רוגע',
    titleAr: 'هادئ',
    titleRu: 'Спокойный'
  },
  {
    cardType: 'FEEL',
    isPositive: false,
    description: 'Enraged; greatly provoked or irritated, angry.',
    descriptionHe: 'כועס מאוד; נסער או מרוגז.',
    descriptionAr: 'غاضب بشدة؛ مستفَز أو منزعج.',
    descriptionRu: 'В ярости; сильно раздражён или зол.',
    emoji: '😡',
    title: 'Anger',
    titleHe: 'כעס',
    titleAr: 'غضب',
    titleRu: 'Злость'
  },
  {
    cardType: 'FEEL',
    isPositive: true,
    description: 'An expression or appearance of merriment or amusement.',
    descriptionHe: 'הבעת שמחה או שעשוע.',
    descriptionAr: 'تعبير عن الفرح أو التسلية.',
    descriptionRu: 'Выражение радости или веселья.',
    emoji: '😆',
    title: 'Laughter',
    titleHe: 'צחוק',
    titleAr: 'ضحك',
    titleRu: 'Смех'
  },
  {
    cardType: 'FEEL',
    isPositive: true,
    description: 'To be physically drawn to another.',
    descriptionHe: 'משיכה פיזית כלפי אדם אחר.',
    descriptionAr: 'انجذاب جسدي تجاه شخص آخر.',
    descriptionRu: 'Физическое влечение к другому человеку.',
    emoji: '😘',
    title: 'Attraction',
    titleHe: 'משיכה',
    titleAr: 'انجذاب',
    titleRu: 'Привлечение'
  },
  {
      cardType: 'FEEL',
      isPositive: true,
      description: 'Feeling or expressing gratitude.',
      descriptionHe: 'להרגיש או להביע תודה.',
      descriptionAr: 'الشعور أو التعبير عن الامتنان.',
      descriptionRu: 'Чувствовать или выражать благодарность.',
      emoji: '🙏',
      title: 'Thankful',
      titleHe: 'אסיר/ת תודה',
      titleAr: 'شاكر',
      titleRu: 'Благодарный'
  },
  {
      cardType: 'FEEL',
      isPositive: false,
      description: 'Hurt by what feels like a deliberate act or display of disrespect.',
      descriptionHe: 'פגיעה עקב תחושה של מעשה מכוון או זלזול.',
      descriptionAr: 'التأذي من فعل مقصود أو إظهار عدم احترام.',
      descriptionRu: 'Обижен тем, что кажется преднамеренным действием или проявлением неуважения.',
      emoji: '😢',
      title: 'Insult',
      titleHe: 'עלבון',
      titleAr: 'إهانة',
      titleRu: 'Оскорбление'
  },
  {
      cardType: 'FEEL',
      isPositive: false,
      description: 'Made by someone seem unimportant.',
      descriptionHe: 'תחושה שמישהו ממעיט בערכך.',
      descriptionAr: 'جعلك شخص ما تشعر بأنك غير مهم.',
      descriptionRu: 'Чувствовать себя неважным из-за действий другого человека.',
      emoji: '🐣',
      title: 'Belittled',
      titleHe: 'הקטנה',
      titleAr: 'تحقير',
      titleRu: 'Приниженный'
  },
  {
      cardType: 'FEEL',
      isPositive: false,
      description: 'Actively aggressive, fighting back.',
      descriptionHe: 'תוקפני באופן פעיל, משיב מלחמה.',
      descriptionAr: 'عدواني بنشاط، يرد الهجوم.',
      descriptionRu: 'Активно агрессивный, дающий отпор.',
      emoji: '⚔',
      title: 'Offensive',
      titleHe: 'במגננה',
      titleAr: 'هجومي',
      titleRu: 'Агрессивный'
  },
  {
      cardType: 'FEEL',
      isPositive: false,
      description: 'Dull, without spirit.',
      descriptionHe: 'עייף, חסר מרץ או אנרגיה.',
      descriptionAr: 'مرهق أو فاقد للحيوية.',
      descriptionRu: 'Вялый, без энергии.',
      emoji: '😔',
      title: 'Exhausted',
      titleHe: 'תשישות',
      titleAr: 'مرهق',
      titleRu: 'Истощённый'
  },
  {
      cardType: 'FEEL',
      isPositive: false,
      description: 'Feel fear or terror, frightened, alarmed.',
      descriptionHe: 'תחושה של פחד או אימה.',
      descriptionAr: 'شعور بالخوف أو الذعر.',
      descriptionRu: 'Чувствовать страх или ужас.',
      emoji: '😨',
      title: 'Fear',
      titleHe: 'פחד',
      titleAr: 'خوف',
      titleRu: 'Страх'
  },
  {
      cardType: 'FEEL',
      isPositive: true,
      description: 'Not broken, damaged, or impaired; intact.',
      descriptionHe: 'לא שבור, פגום או פגוע; שלם.',
      descriptionAr: 'غير مكسور أو متضرر؛ سليم.',
      descriptionRu: 'Не сломанный, не повреждённый; целый.',
      emoji: '🌝',
      title: 'Whole',
      titleHe: 'שלמות',
      titleAr: 'كامل',
      titleRu: 'Целостный'
  },
  {
      cardType: 'FEEL',
      isPositive: false,
      description: 'Misled by a false appearance or statement.',
      descriptionHe: 'הוטעה על ידי מראה או הצהרה שקרית.',
      descriptionAr: 'تم تضليلك بمظهر أو تصريح كاذب.',
      descriptionRu: 'Введён в заблуждение ложным видом или заявлением.',
      emoji: '😧',
      title: 'Deceived',
      titleHe: 'מרומה',
      titleAr: 'مخدوع',
      titleRu: 'Обманутый'
  },
  {
      cardType: 'FEEL',
      isPositive: false,
      description: 'A strong distaste, nausea, loathing.',
      descriptionHe: 'תחושת גועל חזקה או בחילה.',
      descriptionAr: 'اشمئزاز قوي أو غثيان.',
      descriptionRu: 'Сильное отвращение или тошнота.',
      emoji: '🤢',
      title: 'Disgust',
      titleHe: 'גועל',
      titleAr: 'اشمئزاز',
      titleRu: 'Отвращение'
  },
  {
      cardType: 'FEEL',
      isPositive: false,
      description: 'Feel a painful loss of pride, self-respect, or dignity.',
      descriptionHe: 'תחושת אובדן כואב של גאווה, כבוד עצמי או כבוד.',
      descriptionAr: 'شعور بفقدان مؤلم للفخر أو الاحترام أو الكرامة.',
      descriptionRu: 'Чувствовать болезненную потерю гордости, самоуважения или достоинства.',
      emoji: '😳',
      title: 'Humiliated',
      titleHe: 'השפלה',
      titleAr: 'مهان',
      titleRu: 'Униженный'
  },
  {
      cardType: 'FEEL',
      isPositive: false,
      description: 'Expressing a strong dislike.',
      descriptionHe: 'ביטוי של חוסר חיבה עזה.',
      descriptionAr: 'التعبير عن كراهية قوية.',
      descriptionRu: 'Выражение сильной неприязни.',
      emoji: '👿',
      title: 'Hatred',
      titleHe: 'שנאה',
      titleAr: 'كراهية',
      titleRu: 'Ненависть'
  },
  {
      cardType: 'FEEL',
      isPositive: false,
      description: "Feeling resentment against someone because of that person's rivalry, success, or advantage.",
      descriptionHe: 'תחושת טינה כלפי מישהו עקב יריבות, הצלחה או יתרון.',
      descriptionAr: 'شعور بالاستياء تجاه شخص بسبب المنافسة أو النجاح أو التفوق.',
      descriptionRu: 'Чувство обиды на кого-то из-за его соперничества, успеха или преимущества.',
      emoji: '😒',
      title: 'Jealous',
      titleHe: 'קינאה',
      titleAr: 'غيرة',
      titleRu: 'Завистливый'
  },
  {
      cardType: 'FEEL',
      isPositive: false,
      description: 'Distrustful, questioning another person.',
      descriptionHe: 'חשדני, מטיל ספק באדם אחר.',
      descriptionAr: 'مرتاب ويشكك في شخص آخر.',
      descriptionRu: 'Недоверчивый, сомневающийся в другом человеке.',
      emoji: '🤔',
      title: 'Suspicious',
      titleHe: 'חשד',
      titleAr: 'مشبوه',
      titleRu: 'Подозрительный'
  },
  {
      cardType: 'FEEL',
      isPositive: false,
      description: 'To leave completely and finally; forsake utterly; desert.',
      descriptionHe: 'לעזוב לגמרי ולנטוש לחלוטין.',
      descriptionAr: 'الرحيل تمامًا وترك الشيء كليًا.',
      descriptionRu: 'Покинуть полностью и окончательно; оставить навсегда.',
      emoji: '🙇‍♂️',
      title: 'Abandoned',
      titleHe: 'נטישה',
      titleAr: 'مهجور',
      titleRu: 'Покинутый'
  },
  {
      cardType: 'FEEL',
      isPositive: false,
      description: 'A feeling of responsibility or remorse.',
      descriptionHe: 'תחושה של אחריות או חרטה.',
      descriptionAr: 'شعور بالمسؤولية أو الندم.',
      descriptionRu: 'Чувство ответственности или раскаяния.',
      emoji: '⚖️',
      title: 'Guilt',
      titleHe: 'אשם/ה',
      titleAr: 'ذنب',
      titleRu: 'Вина'
  },
  {
      cardType: 'FEEL',
      isPositive: false,
      description: 'A feeling of dissatisfaction due to unmet expectations.',
      descriptionHe: 'תחושת חוסר שביעות רצון עקב ציפיות שלא התממשו.',
      descriptionAr: 'شعور بعدم الرضا بسبب توقعات لم تتحقق.',
      descriptionRu: 'Чувство неудовлетворённости из-за несбывшихся ожиданий.',
      emoji: '😔',
      title: 'Disappointment',
      titleHe: 'אכזבה',
      titleAr: 'خيبة أمل',
      titleRu: 'Разочарование'
  },
  {
      cardType: 'FEEL',
      isPositive: false,
      description: 'Feeling sorrow or unhappiness.',
      descriptionHe: 'תחושה של עצב או חוסר שמחה.',
      descriptionAr: 'شعور بالحزن أو التعاسة.',
      descriptionRu: 'Чувство печали или несчастья.',
      emoji: '😥',
      title: 'Sad',
      titleHe: 'עצב',
      titleAr: 'حزن',
      titleRu: 'Грустный'
  },
  {
      cardType: 'FEEL',
      isPositive: true,
      description: 'Feeling content and pleased with what you have or achieved.',
      descriptionHe: 'תחושת שביעות רצון ממה שיש או הושג.',
      descriptionAr: 'الشعور بالرضا عن ما لديك أو ما حققته.',
      descriptionRu: 'Чувство удовлетворённости тем, что есть или достигнуто.',
      emoji: '🙂',
      title: 'Satisfied',
      titleHe: 'שביעות רצון',
      titleAr: 'راضٍ',
      titleRu: 'Доволен'
  },
  {
      cardType: 'FEEL',
      isPositive: false,
      description: 'A deep emotional yearning for someone or something.',
      descriptionHe: 'געגוע עמוק למישהו או למשהו.',
      descriptionAr: 'اشتياق عميق لشخص أو لشيء ما.',
      descriptionRu: 'Глубокая эмоциональная тоска по кому-то или чему-то.',
      emoji: '😕',
      title: 'Longing',
      titleHe: 'געגוע',
      titleAr: 'اشتياق',
      titleRu: 'Тоска'
  },
  {
      cardType: 'FEEL',
      isPositive: false,
      description: 'Feeling worried, uneasy, or nervous about something.',
      descriptionHe: 'תחושה של דאגה, חוסר מנוחה או עצבנות ממשהו.',
      descriptionAr: 'الشعور بالقلق أو التوتر أو الانزعاج من شيء ما.',
      descriptionRu: 'Чувство тревоги, беспокойства или нервозности по поводу чего-то.',
      emoji: '😰',
      title: 'Anxious',
      titleHe: 'חרדה',
      titleAr: 'قلق',
      titleRu: 'Тревожный'
  },
  {
      cardType: 'FEEL',
      isPositive: false,
      description: 'Feeling regret for something you did or failed to do.',
      descriptionHe: 'תחושת חרטה על משהו שעשית או לא עשית.',
      descriptionAr: 'الشعور بالندم على شيء فعلته أو لم تفعله.',
      descriptionRu: 'Чувство сожаления о том, что сделал или не сделал.',
      emoji: '😞',
      title: 'Sorry',
      titleHe: 'חרטה',
      titleAr: 'آسف',
      titleRu: 'Сожалею'
  },
  {
      cardType: 'FEEL',
      isPositive: false,
      description: 'Feeling let down or disappointed.',
      descriptionHe: 'תחושת אכזבה או נפילה ברוח.',
      descriptionAr: 'الشعور بخيبة الأمل أو الإحباط.',
      descriptionRu: 'Чувство разочарования или упадка духа.',
      emoji: '🙁',
      title: 'Bummed out',
      titleHe: 'באסה',
      titleAr: 'محبط',
      titleRu: 'Расстроен'
  },
  {
      cardType: 'FEEL',
      isPositive: false,
      description: 'A persistent feeling of sadness and loss of interest.',
      descriptionHe: 'תחושת עצב מתמשכת ואובדן עניין.',
      descriptionAr: 'شعور دائم بالحزن وفقدان الاهتمام.',
      descriptionRu: 'Постоянное чувство грусти и потери интереса.',
      emoji: '😞',
      title: 'Depressed',
      titleHe: 'דיכאון',
      titleAr: 'اكتئاب',
      titleRu: 'В депрессии'
  },
  {
      cardType: 'FEEL',
      isPositive: false,
      description: 'Expressing sorrow through tears.',
      descriptionHe: 'הבעת עצב דרך דמעות.',
      descriptionAr: 'التعبير عن الحزن بالدموع.',
      descriptionRu: 'Выражение печали через слёзы.',
      emoji: '😭',
      title: 'Cry',
      titleHe: 'בוכה',
      titleAr: 'بكاء',
      titleRu: 'Плачет'
  },
  {
      cardType: 'FEEL',
      isPositive: false,
      description: 'A complete loss of hope.',
      descriptionHe: 'אובדן מוחלט של תקווה.',
      descriptionAr: 'فقدان كامل للأمل.',
      descriptionRu: 'Полная потеря надежды.',
      emoji: '😔',
      title: 'Despair',
      titleHe: 'ייאוש',
      titleAr: 'يأس',
      titleRu: 'Отчаяние'
  },
  {
      cardType: 'FEEL',
      isPositive: true,
      description: 'A feeling of expectation and desire for a certain thing to happen.',
      descriptionHe: 'תחושת ציפייה ורצון שמשהו מסוים יקרה.',
      descriptionAr: 'شعور بالتوقع والرغبة في حدوث شيء ما.',
      descriptionRu: 'Чувство ожидания и желания, чтобы что-то произошло.',
      emoji: '🙏',
      title: 'Hope',
      titleHe: 'תקווה',
      titleAr: 'أمل',
      titleRu: 'Надежда'
  }
]

const needCardsRaw = [
  {
    cardType: 'NEED',
    isPositive: false,
    description: 'Uncertain about what is required or desired.',
    descriptionHe: 'חוסר ודאות לגבי מה נדרש או רצוי.',
    descriptionAr: 'غير متأكد مما هو مطلوب أو مرغوب.',
    descriptionRu: 'Неуверенность в том, что требуется или желается.',
    emoji: '🤔',
    title: "I don't know",
    titleHe: 'אני לא יודע/ת',
    titleAr: 'لا أعرف',
    titleRu: 'Я не знаю'
  },
  {
    cardType: 'NEED',
    isPositive: false,
    description: 'Choosing not to reveal or disclose something.',
    descriptionHe: 'בחירה לא לחשוף או לשתף משהו.',
    descriptionAr: 'اختيار عدم الكشف أو المشاركة في شيء ما.',
    descriptionRu: 'Выбор не раскрывать или не делиться чем-то.',
    emoji: '🙊',
    title: "I don't want to share",
    titleHe: 'לא בא לי לשתף',
    titleAr: 'لا أريد أن أشارك',
    titleRu: 'Я не хочу делиться'
  },
  {
    cardType: 'NEED',
    isPositive: false,
    description: 'No specific need or requirement at the moment.',
    descriptionHe: 'אין צורך או דרישה מסוימת כרגע.',
    descriptionAr: 'لا يوجد احتياج أو مطلب محدد في الوقت الحالي.',
    descriptionRu: 'В настоящий момент нет конкретного необходимого или требуемого.',
    emoji: '😶',
    title: 'Nothing',
    titleHe: 'שום דבר',
    titleAr: 'لا شيء',
    titleRu: 'Ничего'
  },
  {
    cardType: 'NEED',
    isPositive: false,
    description: 'A desire to be by oneself without interaction or disturbance.',
    descriptionHe: 'רצון להיות לבד בלי אינטראקציה או הפרעה.',
    descriptionAr: 'الرغبة في أن أكون وحدي دون تفاعل أو إزعاج.',
    descriptionRu: 'Желание быть одним без взаимодействия или помех.',
    emoji: '🙅‍♂️',
    title: 'Leave me alone',
    titleHe: 'תעזבו אותי בשקט',
    titleAr: 'اتركني وحدي',
    titleRu: 'Оставь меня в покое'
  },
  {
    cardType: 'NEED',
    isPositive: false,
    description: 'A lack of interest, concern, or emotion about something.',
    descriptionHe: 'חוסר עניין, אכפתיות או רגש כלפי משהו.',
    descriptionAr: 'عدم اهتمام أو اكتراث أو شعور تجاه شيء ما.',
    descriptionRu: 'Отсутствие интереса, заботы или эмоций по поводу чего-либо.',
    emoji: '😐',
    title: "I don't care",
    titleHe: 'לא אכפת לי',
    titleAr: 'لا أهتم',
    titleRu: 'Мне всё равно'
  },
  {
    cardType: 'NEED',
    isPositive: true,
    description: 'A deep affection and care for others.',
    descriptionHe: 'חיבה עמוקה ואכפתיות כלפי אחרים.',
    descriptionAr: 'مودة عميقة ورعاية تجاه الآخرين.',
    descriptionRu: 'Глубокая любовь и забота о других.',
    emoji: '❤️',
    title: 'Love',
    titleHe: 'אהבה',
    titleAr: 'حب',
    titleRu: 'Любовь'
  },
  {
    cardType: 'NEED',
    isPositive: true,
    description: 'Recognition and valuing of one’s efforts or qualities.',
    descriptionHe: 'הכרה והערכה למאמצים או לתכונות של אדם.',
    descriptionAr: 'تقدير والاعتراف بجهود أو صفات الشخص.',
    descriptionRu: 'Уважение и признание усилий или качеств человека.',
    emoji: '👏',
    title: 'Appriciation',
    titleHe: 'הערכה',
    titleAr: 'تقدير',
    titleRu: 'Уважение'
  },
  {
    cardType: 'NEED',
    isPositive: true,
    description: 'Understanding things clearly without confusion.',
    descriptionHe: 'הבנה ברורה של הדברים ללא בלבול.',
    descriptionAr: 'فهم الأمور بوضوح دون ارتباك.',
    descriptionRu: 'Понимание вещей без путаницы.',
    emoji: '💎',
    title: 'Clarity',
    titleHe: 'בהירות',
    titleAr: 'وضوح',
    titleRu: 'Ясность'
  },
  {
    cardType: 'NEED',
    isPositive: true,
    description: 'To feel noticed and acknowledged.',
    descriptionHe: 'להרגיש שרואים ומכירים בקיומי.',
    descriptionAr: 'أن أشعر بأنني مرئي ومعترف بي.',
    descriptionRu: 'Чувствовать, что меня замечают и признают.',
    emoji: '👁️',
    title: 'To be seen',
    titleHe: 'שיראו אותי',
    titleAr: 'أن يُراني الآخرون',
    titleRu: 'Чтобы меня замечали'
  },
  {
    cardType: 'NEED',
    isPositive: true,
    description: 'To grasp or comprehend something.',
    descriptionHe: 'לתפוס או להבין משהו.',
    descriptionAr: 'استيعاب أو فهم شيء ما.',
    descriptionRu: 'Понимание чего-то.',
    emoji: '🤔',
    title: 'To understand',
    titleHe: 'להבין',
    titleAr: 'أن أفهم',
    titleRu: 'Понимать'
  },
  {
    cardType: 'NEED',
    isPositive: true,
    description: 'For others to grasp or comprehend me.',
    descriptionHe: 'שאנשים אחרים יבינו אותי.',
    descriptionAr: 'أن يفهمني الآخرون.',
    descriptionRu: 'Чтобы меня поняли.',
    emoji: '😇',
    title: 'To be understood',
    titleHe: 'שיבינו אותי',
    titleAr: 'أن يتم فهمي',
    titleRu: 'Чтобы меня поняли'
  },
  {
    cardType: 'NEED',
    isPositive: true,
    description: 'Receiving assistance, comfort, or encouragement from others.',
    descriptionHe: 'קבלת עזרה, נוחות או עידוד מאחרים.',
    descriptionAr: 'تلقي المساعدة أو الراحة أو التشجيع من الآخرين.',
    descriptionRu: 'Получение помощи, поддержки или подбадривания от других.',
    emoji: '🤝',
    title: 'Get support',
    titleHe: 'לקבל תמיכה',
    titleAr: 'الحصول على الدعم',
    titleRu: 'Получить поддержку'
  },
  {
    cardType: 'NEED',
    isPositive: true,
    description: 'The ability to wait calmly without frustration.',
    descriptionHe: 'היכולת להמתין בשקט ללא תסכול.',
    descriptionAr: 'القدرة على الانتظار بهدوء دون إحباط.',
    descriptionRu: 'Способность терпеливо ждать без раздражения.',
    emoji: '⏳',
    title: 'Patience',
    titleHe: 'סבלנות',
    titleAr: 'صبر',
    titleRu: 'Терпение'
  },
  {
    cardType: 'NEED',
    isPositive: true,
    description: 'A period available for doing something or resting.',
    descriptionHe: 'פרק זמן פנוי לעשות משהו או לנוח.',
    descriptionAr: 'فترة متاحة لفعل شيء ما أو للراحة.',
    descriptionRu: 'Период времени, когда можно делать что-то или отдыхать.',
    emoji: '🕑',
    title: 'Time',
    titleHe: 'זמן',
    titleAr: 'وقت',
    titleRu: 'Время'
  },
  {
    cardType: 'NEED',
    isPositive: true,
    description: 'Freedom from noise or disturbances.',
    descriptionHe: 'חופש מרעש או מהפרעות.',
    descriptionAr: 'الحرية من الضوضاء أو الإزعاج.',
    descriptionRu: 'Свобода от шума или помех.',
    emoji: '🔇',
    title: 'Quiet',
    titleHe: 'שקט',
    titleAr: 'هدوء',
    titleRu: 'Тишина'
  },
  {
    cardType: 'NEED',
    isPositive: true,
    description: 'For others to have confidence in me.',
    descriptionHe: 'שאנשים אחרים יאמינו בי.',
    descriptionAr: 'أن يثق بي الآخرون.',
    descriptionRu: 'Чтобы другие доверяли мне.',
    emoji: '🙌',
    title: 'Receive trust',
    titleHe: 'שיאמינו בי',
    titleAr: 'تلقي الثقة',
    titleRu: 'Получить доверие'
  },
  {
    cardType: 'NEED',
    isPositive: true,
    description: 'Physical or mental strength to act or function.',
    descriptionHe: 'כוח פיזי או מנטלי לפעול או לתפקד.',
    descriptionAr: 'القوة الجسدية أو العقلية للعمل أو الأداء.',
    descriptionRu: 'Физическая или психическая сила для действий или функций.',
    emoji: '🔋',
    title: 'Energy',
    titleHe: 'אנרגיה',
    titleAr: 'طاقة',
    titleRu: 'Энергия'
  },
  {
    cardType: 'NEED',
    isPositive: true,
    description: 'To receive assistance from others.',
    descriptionHe: 'לקבל עזרה מאחרים.',
    descriptionAr: 'تلقي المساعدة من الآخرين.',
    descriptionRu: 'Получение помощи от других.',
    emoji: '✋',
    title: 'Help',
    titleHe: 'עזרה',
    titleAr: 'مساعدة',
    titleRu: 'Помощь'
  },
  {
    cardType: 'NEED',
    isPositive: true,
    description: 'Warmth, affection, or closeness from others.',
    descriptionHe: 'חום, חיבה או קירבה מאחרים.',
    descriptionAr: 'الدفء أو المودة أو القرب من الآخرين.',
    descriptionRu: 'Теплота, любовь или близость от других.',
    emoji: '😊',
    title: 'Attraction',
    titleHe: 'חום',
      titleAr: 'دفء',
    titleRu: 'Притяжение'
  },
  {
    cardType: 'NEED',
    isPositive: true,
    description: 'A period of relaxation or sleep.',
    descriptionHe: 'זמן של רגיעה או שינה.',
    descriptionAr: 'فترة من الاسترخاء أو النوم.',
    descriptionRu: 'Период отдыха или сна.',
    emoji: '😴',
    title: 'Rest',
    titleHe: 'מנוחה',
    titleAr: 'راحة',
    titleRu: 'Отдых'
  },
  {
    cardType: 'NEED',
    isPositive: true,
    description: 'The desire to experience joy and positive emotions.',
    descriptionHe: 'הרצון לחוות שמחה ורגשות חיוביים.',
    descriptionAr: 'الرغبة في عيش الفرح والمشاعر الإيجابية.',
    descriptionRu: 'Желание испытывать радость и положительные эмоции.',
    emoji: '😀',
    title: 'To be happy',
    titleHe: 'לשמוח',
    titleAr: 'أن أكون سعيدًا',
    titleRu: 'Чтобы быть счастливым'
  },
  {
    cardType: 'NEED',
    isPositive: true,
    description: 'The need to express joy through laughter.',
    descriptionHe: 'הצורך להביע שמחה דרך צחוק.',
    descriptionAr: 'الحاجة للتعبير عن الفرح من خلال الضحك.',
    descriptionRu: 'Желание выразить радость через смех.',
    emoji: '🤣',
    title: 'To laugh',
    titleHe: 'לצחוק',
    titleAr: 'أن أضحك',
    titleRu: 'Чтобы смеяться'
  },
  {
    cardType: 'NEED',
    isPositive: true,
    description: 'The need for focus and consideration from others.',
    descriptionHe: 'הצורך בהתמקדות ובמתן תשומת לב מאחרים.',
    descriptionAr: 'الحاجة إلى التركيز والحصول على الاهتمام من الآخرين.',
    descriptionRu: 'Желание получить внимание и внимание от других.',
    emoji: '✋',
    title: 'Attention',
    titleHe: 'תשומת לב',
    titleAr: 'الاهتمام',
    titleRu: 'Внимание'
  },
  {
    cardType: 'NEED',
    isPositive: true,
    description: 'The desire for friendly and considerate treatment.',
    descriptionHe: 'הרצון ליחס ידידותי ומתחשב.',
    descriptionAr: 'الرغبة في معاملة ودودة ومراعية.',
    descriptionRu: 'Желание быть доброжелательным и внимательным.',
    emoji: '😊',
    title: 'Kindness',
    titleHe: 'אדיבות',
    titleAr: 'اللطف',
    titleRu: 'Доброта'
  },
  {
    cardType: 'NEED',
    isPositive: true,
    description: 'The desire for others to show warmth and care towards me.',
    descriptionHe: 'הרצון שאחרים יפגינו כלפיי חיבה וחום.',
    descriptionAr: 'الرغبة في أن يظهر الآخرون لي المودة والدفء.',
    descriptionRu: 'Желание получить теплоту, любовь или близость от других.',
    emoji: '😌',
    title: 'Affection towards me',
    titleHe: 'שיפגינו כלפיי חיבה',
    titleAr: 'إظهار المودة تجاهي',
    titleRu: 'Притяжение к себе'
  },
  {
    cardType: 'NEED',
    isPositive: true,
    description: 'The need for the ability to act freely without restriction.',
    descriptionHe: 'הצורך ביכולת לפעול בחופשיות ללא הגבלות.',
    descriptionAr: 'الحاجة إلى القدرة على التصرف بحرية دون قيود.',
    descriptionRu: 'Желание быть свободным и действовать без ограничений.',
    emoji: '🕊️',
    title: 'Freedom',
    titleHe: 'חופשיות',
    titleAr: 'الحرية',
    titleRu: 'Свобода'
  },
  {
    cardType: 'NEED',
    isPositive: true,
    description: 'The need for self-reliance and autonomy.',
    descriptionHe: 'הצורך בעצמאות וביכולת להסתמך על עצמי.',
    descriptionAr: 'الحاجة إلى الاستقلالية والاعتماد على النفس.',
    descriptionRu: 'Желание быть независимым и действовать самостоятельно.',
    emoji: '✊',
    title: 'Independence',
    titleHe: 'עצמאות',
    titleAr: 'الاستقلال',
    titleRu: 'Независимость'
  },
  {
    cardType: 'NEED',
    isPositive: true,
    description: 'The desire for tasks or situations that push my limits.',
    descriptionHe: 'הרצון למשימות או מצבים שמאתגרים אותי.',
    descriptionAr: 'الرغبة في المهام أو المواقف التي تتحداني.',
    descriptionRu: 'Желание выполнять задачи или ситуации, которые вызывают трудности.',
    emoji: '🏁',
    title: 'Challenge',
    titleHe: 'אתגר',
    titleAr: 'التحدي',
    titleRu: 'Вызов'
  },
  {
    cardType: 'NEED',
    isPositive: true,
    description: 'The desire to express myself through imagination and creation.',
    descriptionHe: 'הרצון לבטא את עצמי דרך דמיון ויצירה.',
    descriptionAr: 'الرغبة في التعبير عن نفسي من خلال الخيال والإبداع.',
    descriptionRu: 'Желание выразить себя через воображение и творчество.',
    emoji: '🎨',
    title: 'Creativity',
    titleHe: 'יצירתיות',
    titleAr: 'الإبداع',
    titleRu: 'Творчество'
  },
  {
    cardType: 'NEED',
    isPositive: true,
    description: 'The desire to have new and innovative concepts.',
    descriptionHe: 'הרצון לרעיונות חדשים וחדשניים.',
    descriptionAr: 'الرغبة في امتلاك أفكار جديدة ومبتكرة.',
    descriptionRu: 'Желание иметь новые и инновационные идеи.',
    emoji: '💡',
    title: 'Idea',
    titleHe: 'רעיון',
    titleAr: 'فكرة',
    titleRu: 'Идея'
  },
  {
    cardType: 'NEED',
    isPositive: true,
    description: 'The desire to believe in positive possibilities for the future.',
    descriptionHe: 'הרצון להאמין באפשרויות חיוביות לעתיד.',
    descriptionAr: 'الرغبة في الإيمان بالاحتمالات الإيجابية للمستقبل.',
    descriptionRu: 'Желание верить в положительные возможности будущего.',
    emoji: '🙏',
    title: 'Hope',
    titleHe: 'תקווה',
    titleAr: 'الأمل',
    titleRu: 'Надежда'
  },
  {
    cardType: 'NEED',
    isPositive: true,
    description: 'The need to achieve results effectively with minimal waste.',
    descriptionHe: 'הצורך להשיג תוצאות ביעילות ובפחות בזבוז.',
    descriptionAr: 'الحاجة إلى تحقيق النتائج بكفاءة وبأقل هدر.',
    descriptionRu: 'Желание достичь результатов с минимальными потерями.',
    emoji: '🎯',
    title: 'Efficiency',
    titleHe: 'יעילות',
    titleAr: 'الكفاءة',
    titleRu: 'Эффективность'
  },
  {
    cardType: 'NEED',
    isPositive: true,
    description: 'The desire to gain knowledge or skills.',
    descriptionHe: 'הרצון לרכוש ידע או מיומנויות.',
    descriptionAr: 'الرغبة في اكتساب المعرفة أو المهارات.',
    descriptionRu: 'Желание получить знания или навыки.',
    emoji: '🎓',
    title: 'To learn',
    titleHe: 'ללמוד',
    titleAr: 'أن أتعلم',
    titleRu: 'Учиться'
  },
  {
    cardType: 'NEED',
    isPositive: true,
    description: 'The wish for favorable outcomes in life.',
    descriptionHe: 'המשאלה לתוצאות חיוביות בחיים.',
    descriptionAr: 'التمني للحصول على نتائج إيجابية في الحياة.',
    descriptionRu: 'Желание получить удачу в жизни.',
    emoji: '🍀',
    title: 'Luck',
    titleHe: 'מזל',
    titleAr: 'الحظ',
    titleRu: 'Удача'
  },
  {
    cardType: 'NEED',
    isPositive: true,
    description: 'The desire to be valued and recognized by others.',
    descriptionHe: 'הרצון שיעריכו אותי ויכירו בי.',
    descriptionAr: 'الرغبة في أن يقدرني الآخرون ويعترفوا بي.',
    descriptionRu: 'Желание быть оцененным и признанным другими.',
    emoji: '👏',
    title: 'Receive appreciation',
    titleHe: 'לקבל הערכה',
    titleAr: 'تلقي التقدير',
    titleRu: 'Получить признание'
  },
  {
    cardType: 'NEED',
    isPositive: true,
    description: 'The need to feel vibrant and full of life.',
    descriptionHe: 'הצורך להרגיש מלא/ת חיים ותוסס/ת.',
    descriptionAr: 'الحاجة إلى الشعور بالحيوية والنشاط.',
    descriptionRu: 'Желание чувствовать себя живой и полной жизни.',
    emoji: '🧟',
    title: 'To feel alive',
    titleHe: 'להרגיש חי/ה',
    titleAr: 'أن أشعر بالحياة',
    titleRu: 'Чтобы чувствовать себя живой'
  },
  {
    cardType: 'NEED',
    isPositive: true,
    description: 'The need for companionship and connection with friends.',
    descriptionHe: 'הצורך בחברות ובקשר עם חברים.',
    descriptionAr: 'الحاجة إلى الصداقة والتواصل مع الأصدقاء.',
    descriptionRu: 'Желание иметь друзей и общение с ними.',
    emoji: '👨‍👩‍👧‍👦',
    title: 'My friends',
    titleHe: 'החברים שלי',
    titleAr: 'أصدقائي',
    titleRu: 'Мои друзья'
  },
  {
    cardType: 'NEED',
    isPositive: true,
    description: 'The desire to reach a state of relaxation and emotional ease.',
    descriptionHe: 'הרצון להגיע למצב של רוגע ונינוחות רגשית.',
    descriptionAr: 'الرغبة في الوصول إلى حالة من الهدوء والراحة العاطفية.',
    descriptionRu: 'Желание достичь состояния покоя и эмоционального комфорта.',
    emoji: '🌡',
    title: 'Calm down',
    titleHe: 'להרגע',
    titleAr: 'أن أهدأ',
    titleRu: 'Успокоиться'
  },
  {
    cardType: 'NEED',
    isPositive: true,
    description: 'The wish for new and exciting experiences.',
    descriptionHe: 'המשאלה לחוויות חדשות ומלהיבות.',
    descriptionAr: 'التمني لخوض تجارب جديدة ومثيرة.',
    descriptionRu: 'Желание испытывать новые и захватывающие опыты.',
    emoji: '🗺',
    title: 'Adventure',
    titleHe: 'הרפתקאה',
    titleAr: 'المغامرة',
    titleRu: 'Приключение'
  },
  {
    cardType: 'NEED',
    isPositive: true,
    description: 'The need to be driven to take action or achieve goals.',
    descriptionHe: 'הצורך להיות מונע לפעול או להשיג מטרות.',
    descriptionAr: 'الحاجة إلى أن أكون مدفوعًا للعمل أو لتحقيق الأهداف.',
    descriptionRu: 'Желание быть мотивированным и действовать для достижения целей.',
    emoji: '🤩',
    title: 'Motivation',
    titleHe: 'מוטיבציה',
    titleAr: 'الدافع',
    titleRu: 'Мотивация'
  },
  {
    cardType: 'NEED',
    isPositive: true,
    description: 'The desire to be treated with dignity and regard.',
    descriptionHe: 'הרצון שיתייחסו אליי בכבוד ובהערכה.',
    descriptionAr: 'الرغبة في أن يُعاملني الآخرون بكرامة واحترام.',
    descriptionRu: 'Желание быть уважаемым и уважать других.',
    emoji: '😌',
    title: 'Receive respect',
    titleHe: 'לקבל כבוד',
    titleAr: 'تلقي الاحترام',
    titleRu: 'Получить уважение'
  },
  {
    cardType: 'NEED',
    isPositive: true,
    description: 'The need for others to speak truthfully with me.',
    descriptionHe: 'הצורך שאחרים ידברו איתי בכנות.',
    descriptionAr: 'الحاجة لأن يتحدث الآخرون معي بصدق.',
    descriptionRu: 'Желание быть честным и искренним в общении.',
    emoji: '😇',
    title: 'Honesty with me',
    titleHe: 'כנות איתי',
    titleAr: 'الصدق معي',
    titleRu: 'Честность'
  },
  {
    cardType: 'NEED',
    isPositive: true,
    description: 'The need for others to respect my authority.',
    descriptionHe: 'הצורך שיתייחסו אליי בכבוד.',
    descriptionAr: 'الحاجة إلى أن يقدرني الآخرون.',
    descriptionRu: 'Желание быть уважаемым и уважать других.',
    emoji: '🤠',
    title: 'Authority',
    titleHe: 'שיתנו לי סמכות',
    titleAr: 'أن يمنحوني سلطة',
    titleRu: 'Получить уважение'
  },
  {
    cardType: 'NEED',
    isPositive: true,
    description: 'The need for others to feel connected to me.',
    descriptionHe: 'הצורך שיעריכו אותי ויכירו בי.',
    descriptionAr: 'الحاجة إلى أن يقدرني الآخرون.',
    descriptionRu: 'Желание быть уважаемым и уважать других.',
    emoji: '🔗',
    title: 'Connection',
    titleHe: 'קשר',
    titleAr: 'صلة',
    titleRu: 'Связь'
  },
  {
    cardType: 'NEED',
    isPositive: true,
    description: 'The need for others to cheer me up.',
    descriptionHe: 'הצורך שישפרגנו לי.',
    descriptionAr: 'الحاجة إلى أن يشجعوني.',
    descriptionRu: 'Желание быть уважаемым и уважать других.',
    emoji: '🎉',
    title: 'Cheer to me',
    titleHe: 'שיפרגנו לי',
    titleAr: 'أن يشجعوني',
    titleRu: 'Получить поддержку'
  },
  {
    cardType: 'NEED',
    isPositive: true,
    description: 'The need for others to hug me.',
    descriptionHe: 'הצורך שיחבקו אותי.',
    descriptionAr: 'الحاجة إلى أن يقبلوني.',
    descriptionRu: 'Желание быть уважаемым и уважать других.',
    emoji: '🤗',
    title: 'A Hug',
    titleHe: 'שיחבקו אותי',
    titleAr: 'عناق',
    titleRu: 'Получить поддержку'
  },
  {
    cardType: 'NEED',
    isPositive: true,
    description: 'The need for others to leave me alone.',
    descriptionHe: 'הצורך שיניחו לי.',
    descriptionAr: 'الحاجة إلى أن يتركوني.',
    descriptionRu: 'Желание быть уважаемым и уважать других.',
    emoji: '✋',
    title: 'To be left alone',
    titleHe: 'שיניחו לי',
    titleAr: 'أن يتركوني وشأني',
    titleRu: 'Получить поддержку'
  },
  {
    cardType: 'NEED',
    isPositive: true,
    description: 'The need for others to feel I belong.',
    descriptionHe: 'הצורך שיעריכו אותי ויכירו בי.',
    descriptionAr: 'الحاجة إلى أن يقدرني الآخرون.',
    descriptionRu: 'Желание быть уважаемым и уважать других.',
    emoji: '🏠',
    title: 'Feel I belong',
    titleHe: 'להרגיש שייכות',
    titleAr: 'أن أشعر بالانتماء',
    titleRu: 'Получить поддержку'
  },
  {
    cardType: 'NEED',
    isPositive: true,
    description: 'The need for others to listen to me.',
    descriptionHe: 'הצורך שיקשיבו לי.',
    descriptionAr: 'الحاجة إلى أن يستمعوا إلي.',
    descriptionRu: 'Желание быть уважаемым и уважать других.',
    emoji: '👂',
    title: 'To be listened to',
    titleHe: 'שיקשיבו לי',
    titleAr: 'أن يستمعوا إلي',
    titleRu: 'Получить поддержку'
  },
  {
    cardType: 'NEED',
    isPositive: true,
    description: 'The need for others to play with me.',
    descriptionHe: 'הצורך שישחקו איתי.',
    descriptionAr: 'الحاجة إلى أن يلعبوا معي.',
    descriptionRu: 'Желание быть уважаемым и уважать других.',
    emoji: '🏀',
    title: 'To play',
    titleHe: 'לשחק',
    titleAr: 'أن ألعب',
    titleRu: 'Получить поддержку'
  },
  {
    cardType: 'NEED',
    isPositive: true,
    description: 'The need for others to kiss me.',
    descriptionHe: 'הצורך שישפיקו לי.',
    descriptionAr: 'الحاجة إلى أن يقبلوني.',
    descriptionRu: 'Желание быть уважаемым и уважать других.',
    emoji: '😘',
    title: 'A Kiss',
    titleHe: 'נשיקה',
    titleAr: 'قبلة',
    titleRu: 'Получить поддержку'
  },
  {
    cardType: 'NEED',
    isPositive: true,
    description: 'The need for others to be friends with me.',
    descriptionHe: 'הצורך שיהיו חברים איתי.',
    descriptionAr: 'الحاجة إلى أن يكون الآخرون أصدقائي.',
    descriptionRu: 'Желание быть уважаемым и уважать других.',
    emoji: '👫',
    title: 'Friendship',
    titleHe: 'חברות',
    titleAr: 'صداقة',
    titleRu: 'Дружба'
  }
];

const CARD_TYPE_TO_SURVEY_MAP = {
  HAPPENED: 'surveyHappened',
  FEEL: 'surveyFeeling',
  NEED: 'surveyNeeds'
};

const SURVEY_TO_CARD_TYPE_MAP = {
  surveyHappened: 'HAPPENED',
  surveyFeeling: 'FEEL',
  surveyNeeds: 'NEED'
};


const CARD_TYPE_TO_MIRROR = {
  // FEEL: 'feelTowardsPartner' && 'feelTowardsSituation', // TODO: this doesn't work..!
  FEEL: 'feelTowardsPartner',
  NEED: 'whatYouNeed'
}

const MIRROR_TO_CARD_TYPE = {
  feelTowardsPartner: 'FEEL',
  feelTowardsSituation: 'FEEL',
  whatYouNeed : 'NEED'
}

const happenedCards = omitDeep(
  happenedCardsRaw,
  'title_male',
  'title_female',
  'title_other',
  'titleRu',
  'titleRu_male',
  'titleRu_female',
  'titleRu_other',
  'titleHe',
  'titleHe_male',
  'titleHe_female',
  'titleHe_other',
  'titleAr',
  'titleAr_male',
  'titleAr_female',
  'titleAr_other',
  'descriptionRu',
  'descriptionHe',
  'prefixHe'
).map(card => {
  card.prefix = card.prefix ? card.prefix : ' ';
  return card;
});
const feelCards = omitDeep(
  feelCardsRaw,
  'title_male',
  'title_female',
  'title_other',
  'titleRu',
  'titleRu_male',
  'titleRu_female',
  'titleRu_other',
  'titleHe',
  'titleHe_male',
  'titleHe_female',
  'titleHe_other',
  'titleAr',
  'titleAr_male',
  'titleAr_female',
  'titleAr_other',
  'descriptionRu',
  'descriptionHe',
  'prefixHe'
).map(card => {
  card.prefix = card.prefix ? card.prefix : ' ';
  return card;
});
const needCards = omitDeep(
  needCardsRaw,
  'title_male',
  'title_female',
  'title_other',
  'titleRu',
  'titleRu_male',
  'titleRu_female',
  'titleRu_other',
  'titleHe',
  'titleHe_male',
  'titleHe_female',
  'titleHe_other',
  'titleAr',
  'titleAr_male',
  'titleAr_female',
  'titleAr_other',
  'descriptionRu',
  'descriptionHe',
  'prefixHe'
).map(card => {
  card.prefix = card.prefix ? card.prefix : ' ';
  return card;
});
export {
  happenedCardsRaw,
  happenedCards,
  feelCardsRaw,
  feelCards,
  needCardsRaw,
  needCards,
  CARD_TYPE_TO_SURVEY_MAP,
  SURVEY_TO_CARD_TYPE_MAP,
  CARD_TYPE_TO_MIRROR,
  MIRROR_TO_CARD_TYPE
};
